
import { PropTypes } from 'prop-types';
import useFetch from '../../utils/useFetch';
import { retrunAssets } from '../../utils/getAssets';
const InfoCard = ({ item }) => {


    const info = useFetch(item)

    const data = info?.properties
    const alumniName = data?.alumniName
    // const alumniQuote = data?.alumniQuote
    // const alumniCourse = data?.alumniCourse
    const alumniFeedbackTitle = data?.alumniFeedbackTitle
    const alumniFeedbackDescription = data?.alumniFeedbackDescription
    const alumniImage = data?.alumniImage != null ? retrunAssets(data?.alumniImage[0]?.url) : ""

    return (
        <div className="p-4 w-full lg:p-8 bg-white rounded">
            <div className="w-full place-items-center lg:place-items-start grid grid-cols-1 lg:grid-cols-[20%_65%] gap-10">
                <div className="w-[20rem]  relative h-[25rem]   max-h-[25rem] bg-gray-100 bg-center bg-cover bg-no-repeat" style={{ backgroundImage: `url('${alumniImage}')` }}>

                </div>
                <div className="w-full flex flex-col items-center mb-12 lg:items-start gap-5">
                    <div className="flex flex-col items-center lg:items-start gap-1">
                        <h2 className="w-auto  text-slate-900 text-2xl md:text-3xl font-bold ">{alumniName}</h2>
                        <span className="w-auto  text-[#0039CB]  font-bold ">2024</span>
                    </div>
                    <h1 className="w-auto  text-center md:text-start text-slate-900 whitespace-pre-line text-2xl md:text-3xl font-bold ">{alumniFeedbackTitle}</h1>
                    <p className="w-auto   text-justify text-sky-950 text-opacity-70 whitespace-pre-line text-base font-normal leading-normal line-clamp-4 ">{alumniFeedbackDescription}</p>
                </div>
            </div>
        </div>
    )
}
InfoCard.propTypes = {
    item: PropTypes.any
}
export default InfoCard